// hooks/useIdleLogout.js
import { useIdleTimer } from "react-idle-timer";
import { logout } from "../redux/authReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const useIdleLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onIdle = () => {
    dispatch(logout());
    navigate("/");
  };

  useIdleTimer({
    timeout: 1000 * 60 * 60 * 2,
    // timeout: 10000,
    onIdle,
  });
};

export default useIdleLogout;
